import { useSelector } from 'react-redux';
import { Row, Col, Card } from 'antd';

import { selectors } from '@/redux/tour/cruise/view/model';

import CruiseItenerary from './CruiseItenerary';
import CruiseMapItenerary from './CruiseMapItenerary';

const TourItenerary = () => {
    const itenerary = useSelector(selectors.itenerary);
    return (
        <Row>
            <Col lg={14} xs={24} className="map-col">
                <Card bordered={false} className="left-col">
                    <CruiseMapItenerary data={itenerary} />
                </Card>
            </Col>

            <Col lg={10} xs={24}>
                <CruiseItenerary data={itenerary} />
            </Col>
        </Row>
    );
};

export default TourItenerary;
